import React, { Component } from 'react';
import { Card } from 'antd';
import DescriptionList from '@comm/DescriptionList';
import '../expenses.less';
import { queryFilePreview } from '@api/pub/attachment';

const { Description } = DescriptionList;

class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataItem: this.props.data,
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataItem: nextProps.data,
    });
  }

  render() {
    const { dataItem } = this.state;
    const files = dataItem.files || [];
    return (
      <div className="form-open">
        <Card title="划款详情">
          <DescriptionList size="large" col={3}>
            <Description term="划款类型">
              {dataItem.type === '0' ? '自营佣金' : ''}
              {dataItem.type === '1' ? '商家活动费' : ''}
              {dataItem.type === '2' ? '其他' : ''}
            </Description>
            <Description term="申请人员">{dataItem.createUserName}</Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="划款附件">
              <div>
                {files.map(item => {
                  return (
                    <div key={item.url}>
                      <a onClick={() => queryFilePreview(item, '')}>{item.name}</a>
                    </div>
                  );
                })}
              </div>
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="划款说明">{dataItem.reason}</Description>
          </DescriptionList>
        </Card>
      </div>
    );
  }
}

export default Open;



// WEBPACK FOOTER //
// ./src/components/finance/platformTransfer/FormOpen.js